/* eslint-disable camelcase */
type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_deepen_your_practice_with_300_courses_challenges: Phrase = locale => {
  const en = `Deepen Your Practice with 300+ Courses & Challenges`;
  const phrases: { [key: string]: undefined | string } = {
    en,
    es: `Profundiza en tu práctica con más de 300 cursos y desafíos.`,
  };
  return phrases[locale] || en;
};
